<template>
    <div class="node-properties-inner">
        <label>Duration</label>
        <input v-model="properties.duration">
        <label class="units">s</label>
    </div>
</template>

<script>
export default {
    props: {
        properties: { type: Object, required: true }
    }
}
</script>